<template>
  <section v-if="loaded" class="page">
    <!-- HEADER WITH CONTROLS -->
    <v-toolbar>
      <h1>Testimonials display settings</h1>
      <v-spacer />
      <v-btn color="success" @click="onSaveSettings">
        Save changes <v-icon dark right>save</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- HEADER WITH CONTROLS -->

    <!-- DISPLAY SETTINGS -->
    <drag
      :list="displaySettings"
      :options="dragOptions"
    >
      <v-card
        v-for="(type, typeIndex) in displaySettings"
        :key="type.typeId"
        class="type-card"
      >
        <div class="type-card__header">
          <span class="dragable-icon"><v-icon>swap_vert</v-icon></span>
          <h3 v-html="getTypeName(type.typeId)"></h3>
        </div>
        <drag
          v-if="type.testimonials && type.testimonials.length"
          :list="type.testimonials"
          :options="dragOptions"
          class="testimonials"
        >
          <v-card
            v-for="(testimonial, testimonialIndex) in type.testimonials"
            :key="testimonial.id"
            class="testimonial-card"
          >
            <div class="testimonial-card__header">
               <v-card-actions>
                <v-layout row justify-space-between class="mb-3">
                  <span class="dragable-icon"><v-icon>swap_horiz</v-icon></span>
                   <h3>{{ showCategoryTestimonial(getTestimonial(testimonial.id)) }}</h3>
                  <v-tooltip bottom>
                    <v-btn fab dark
                      slot="activator"
                      @click.stop="openModalBackgroundColor(typeIndex, testimonialIndex)"
                      small color="cyan"
                    >
                      <v-icon dark>brush</v-icon>
                    </v-btn>
                    <span>Choose background color</span>
                  </v-tooltip>
                </v-layout>
              </v-card-actions>
              <v-layout row>
                <h4>Name:</h4><v-spacer /><span>{{ getTestimonial(testimonial.id).employeeName }}</span>
              </v-layout>
              <v-layout row>
                <h4>Company:</h4><v-spacer /><span>{{ getTestimonial(testimonial.id).companyName }}</span>
              </v-layout>
              <v-layout row>
                 <h4>backgroundColor:</h4><v-spacer />
                 <div class="selected-color-box"
                   slot="activator"
                   :style="{background: testimonial.backgroundColor}"></div>
              </v-layout>
            </div>
          </v-card>
        </drag>
      </v-card>
    </drag>
    <!-- DISPLAY SETTINGS -->
    <v-dialog persistent v-model="modalSetBackgroundColor" max-width="500px">
      <v-card>
          <v-card-title>
            Set background color
          </v-card-title>
          <v-card-text>
            <v-select
              :items="backgroundColorSet"
              label="A Select List"
              item-text="name"
              item-value="colorCode"
              v-model="choosedColor"
            >
              <template slot="selection" slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  :disabled="data.disabled"
                  :key="JSON.stringify(data.item)"
                  class="chip--select-multi"
                  @input="data.parent.selectItem(data.item)"
                >
                  <v-avatar :style="{backgroundColor: data.item.colorCode}"></v-avatar>
                  {{ data.item.name }}
                </v-chip>
              </template>
            </v-select>
          </v-card-text>
          <v-card-actions>
            <v-btn color="error" @click.stop="closeModalBackgroundColor">Close</v-btn>
            <v-btn color="success" @click.stop="setBeckgroundColor">Set beckground color</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </section>
</template>

<script>
  import { clone, propEq, find, pathOr, sortBy, prop, path, isNil } from 'ramda'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'TestimonialsDisplaySettings',
    data () {
      return {
        dragOptions: {
          ghostClass: 'before-drag-drop'
        },
        loaded: false,
        displaySettings: [],
        indexCurrentTestimonial: '',
        indexCurrentType: '',
        choosedColor: '',
        backgroundColorSet: [
          {
            name: 'Dubai Gold',
            colorCode: '#A39161'
          },
          {
            name: 'Dubai Orange',
            colorCode: '#e48c31'
          },
          {
            name: 'Violet',
            colorCode: '#8757F3'
          },
          {
            name: 'Black',
            colorCode: '#221E20'
          },
          {
            name: 'Blue',
            colorCode: '#00A9FF'
          },
          {
            name: 'Red (Material Ui)',
            colorCode: '#D32F2F'
          },
          {
            name: 'Pink (Material Ui)',
            colorCode: '#C2185B'
          },
          {
            name: 'Purple (Material Ui)',
            colorCode: '#7B1FA2'
          },
          {
            name: 'Deep purple (Material Ui)',
            colorCode: '#673AB7'
          },
          {
            name: 'Indigo (Material Ui)',
            colorCode: '#3F51B5'
          },
          {
            name: 'Blue (Material Ui)',
            colorCode: '#2196F3'
          },
          {
            name: 'Light blue (Material Ui)',
            colorCode: '#03A9F4'
          },
          {
            name: 'Cyan (Material Ui)',
            colorCode: '#00BCD4'
          },
          {
            name: 'Teal (Material Ui)',
            colorCode: '#009688'
          },
          {
            name: 'Green (Material Ui)',
            colorCode: '#4CAF50'
          },
          {
            name: 'Light green (Material Ui)',
            colorCode: '#8BC34A'
          },
          {
            name: 'Lime (Material Ui)',
            colorCode: '#CDDC39'
          },
          {
            name: 'Yellow (Material Ui)',
            colorCode: '#FFEB3B'
          },
          {
            name: 'Amber (Material Ui)',
            colorCode: '#FFC107'
          },
          {
            name: 'Orange (Material Ui)',
            colorCode: '#FF9800'
          },
          {
            name: 'Deep orange (Material Ui)',
            colorCode: '#FF5722'
          },
          {
            name: 'Brown (Material Ui)',
            colorCode: '#795548'
          },
          {
            name: 'Grey (Material Ui)',
            colorCode: '#9E9E9E'
          },
          {
            name: 'Blue grey (Material Ui)',
            colorCode: '#607D8B'
          },
          {
            name: 'green (gathering)',
            colorCode: '#3bc2b1'
          },
          {
            name: 'Violet (gathering)',
            colorCode: '#680cc7'
          },
          {
            name: 'Violet2 (gathering)',
            colorCode: '#4f356e'
          },
          {
            name: 'Orange (gathering)',
            colorCode: '#ff8a00'
          },
          {
            name: 'Green (cyprus)',
            colorCode: '#289940'
          },
          {
            name: 'Blue (cyprus)',
            colorCode: '#3d85c6'
          },
          {
            name: 'Blue2 (cyprus)',
            colorCode: '#549af9'
          },
          {
            name: 'Blue3 (cyprus)',
            colorCode: '#2e3693'
          },
          {
            name: 'Red (HK)',
            colorCode: '#7b1818'
          },
          {
            name: 'White',
            colorCode: '#ffffff'
          }
        ],
        modalSetBackgroundColor: false
      }
    },
    computed: {
      ...mapGetters([
        'getLastYearTestimonialById',
        'getTestimonialTypeById',
        'testimonialTypesList',
        'getLastYearTestimonialsByType',
        'cachedTestimonialsDisplaySettings',
        'getSettings'
      ]),
      testimonialsDisplaySettings () {
        return pathOr([], ['lastYearTestimonialsPageSetting', 'metadataObject', 'sections'], this.getSettings)
      },
      getCachedDisplaySettings () {
        return this.cachedTestimonialsDisplaySettings
          ? clone(this.cachedTestimonialsDisplaySettings)
          : []
      },
    },
    methods: {
      ...mapActions([
        'fetchTestimonialTypes',
        'fetchGeneralSettings',
        'fetchPablicLYTestimonials',
        'setTestimonialsDisplaySettings',
        'updateDisplaySettingsTestimonials'
      ]),
      onlyTestimonialsSettings (testimonialsSettings = []) {
        return Array.isArray(testimonialsSettings) && testimonialsSettings.length
          ? testimonialsSettings.reduce((acc, cur) => {
            return [...acc, ...cur.testimonials]
          }, [])
          : []
      },
      async onSaveSettings () {
        this.displaySettings = this.getOrderedSettings(this.displaySettings)
        await this.updateDisplaySettingsTestimonials(this.displaySettings)
        await this.setTestimonialsDisplaySettings(this.displaySettings)
      },
      getTypeName (typeId) {
        const type = this.getTestimonialTypeById(typeId)
        return type.name
      },
      getTestimonial (testimonialId) {
        const testimonial = this.getLastYearTestimonialById(testimonialId)
        return testimonial
      },
      getOrderedSettings (inputSettings) {
        return inputSettings.map((type, typeIndex) => {
          type.order = typeIndex
          type.testimonials.map((testimonial, testimonialIndex) => {
            testimonial.order = testimonialIndex
            return testimonial
          })
          return type
        })
      },
      showCategoryTestimonial (testimonial) {
        const isVideoTestimonial = !!path(['youtubeVideoCode'], testimonial)
        const category = isVideoTestimonial ? 'Video testimonial' : 'Text testimonial'
        return category
      },
      openModalBackgroundColor (typeIndex, testimonialIndex) {
        this.indexCurrentType = typeIndex
        this.indexCurrentTestimonial = testimonialIndex
        this.modalSetBackgroundColor = true
      },
      closeModalBackgroundColor () {
        this.modalSetBackgroundColor = false
        this.choosedColor= ''
      },
      setBeckgroundColor () {
        this.displaySettings[this.indexCurrentType].testimonials[this.indexCurrentTestimonial].backgroundColor = this.choosedColor
        this.closeModalBackgroundColor()
      },
      computedDisplaySetting (id, notAppliedSettings, currentSettings) {
        const findMatchedSettings = find(propEq('id', id))
        const notAppliedTestimonialSettings = findMatchedSettings(this.onlyTestimonialsSettings(notAppliedSettings))
        const currentTestimonialSettings = findMatchedSettings(this.onlyTestimonialsSettings(currentSettings))
        const compareValues = (propertyName, fallback) => {
          const oldPropertyValue = prop(propertyName, currentTestimonialSettings)
          return isNil(oldPropertyValue)
            ? pathOr(fallback, [propertyName], notAppliedTestimonialSettings)
            : oldPropertyValue
        }
        const order = compareValues('order', 0)
        const backgroundColor = compareValues('backgroundColor', '#000000')
        return {
          order,
          backgroundColor
        }
      },
      megreDisplaySettings (testimonialsByType) {
        const sort = sortBy(prop('order'))
        const transformedTestimonials = testimonialsByType.map(cur => {
          const currentTestimonialsSettings = this.computedDisplaySetting(cur.id, this.testimonialsDisplaySettings, this.getCachedDisplaySettings)
          return {
            id: cur.id,
            order:  currentTestimonialsSettings.order,
            backgroundColor: currentTestimonialsSettings.backgroundColor
          }
        })
        return sort(transformedTestimonials)
      },
      getOrderByTypeId (id, notAppliedSettings, currentSettings) {
        const findMatchedSetting = find(propEq('typeId', id))
        const testimonialsOrder = pathOr(
          0,
          ['order'],
          findMatchedSetting(notAppliedSettings)
        )
        const currentTestimonialOrder = path(
          ['order'],
          findMatchedSetting(currentSettings)
        )
        return isNil(currentTestimonialOrder)
          ? testimonialsOrder
          : currentTestimonialOrder
      },
      initDisplaySettings () {
        const testimonialsSettings = this.testimonialTypesList.map(testimonialType => {
          const matchedTestimonials = this.getLastYearTestimonialsByType(testimonialType.id)
          const order = this.getOrderByTypeId(
            testimonialType.id,
            this.testimonialsDisplaySettings,
            this.getCachedDisplaySettings
          )
          return {
            typeId: testimonialType.id,
            order,
            testimonials: this.megreDisplaySettings(matchedTestimonials)
          }
        })
        this.displaySettings = sortBy(
          prop('order'),
          testimonialsSettings
        )
      }
    },
    async mounted () {
      await this.fetchTestimonialTypes()
      await this.fetchPablicLYTestimonials()
      if (!this.getSettings) {
        await this.fetchGeneralSettings()
      }
      this.initDisplaySettings()
      this.loaded = true
    }
  }
</script>

<style lang="scss" scoped>
  .page {
    padding-bottom: 1px;
  }

  .type-card {
    margin: 10px;
    padding: 10px;
    cursor: grab;

    &__header {
      display: flex;
      margin-bottom: 5px;
    }
  }

  .testimonial-card {
    margin: 10px;
    padding: 10px;
    cursor: grab;

    &__header {
      width: 300px;
      margin-bottom: 5px;
    }
  }

  .testimonials {
    display: flex;
  }

  .dragable-icon {
    margin-right: 10px;
  }

  .before-drag-drop {
    opacity: 0.35;
    background: lightgray;
  }

  .selected-color-box {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Testimonials/TestimonialsDisplaySettings/index.vue